<template>
    <div style="height: 100%; font-family: Arial, sans-serif !important;">
        <div class="movie" v-if="accessible">
            <div class="content-movie" style="display: flex;
flex-wrap: wrap;
justify-content: center;
align-content: center;
align-items: center;">
                <div class="section-video" style="margin-top: 70px;">
                    <video
                            v-if="videoLink != null && videoLink.length > 0"
                            :src="videoLink"
                            width="100%"
                            height="50%"
                            controls
                            poster="../../assets/image/player_background.png"
                    ></video>

                    <v-carousel
                            v-if="pdfLink != null && pdfLink.length > 0 && ShowPDF == true"
                            :show-arrows="false"
                            :hide-delimiters="true"
                            class="carousel">
                        <div class="row">
                            <iframe
                                    style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:70px 0 0 0; padding:0 0 60px 0; overflow:hidden; z-index:999999;"
                                    :src="pdfLink"
                                    frameborder="0">
                            </iframe>
                        </div>
                    </v-carousel>
                </div>
                <v-card
                        width="90%"
                        class="box-filemeeting2"
                        style="margin-top: 50px"
                        v-if="ShowPDF == false">
                    <div class="box-filemeeting" >
                        <div class="r-text-boxs-filemeeting">
                            <h6>{{ content_title }}</h6>
                            <span>{{ parent_content_title }}</span>
                            <p>{{ content_voters }}بازدید</p>
                            <h5>{{ content_description }}</h5>
                        </div>
                        <div class="date-boxs-filemeeting">
                            <span>{{ content_duration }}</span>
                            <v-icon>query_builder</v-icon>
                        </div>
                    </div>
                    <div
                            class="btn-box-received"
                            v-if="pdfLink != null && pdfLink.length > 0 && ShowPDF == false"
                    >
                        <v-btn
                                color="#3588e0"
                                style="color: white"
                                width="90%"
                                @click="ShowPDF = true"
                        >
                            مشاهده جلسه آموزشی
                        </v-btn>
                    </div>
                </v-card>
                <div
                        class="section-card"
                        v-if="content_attachments != 0 && content_attachments.length > 0"
                >
                    <v-card class="box-movie" width="90%">
                        <div class="title-movie">
                            <h6>فایلهای ضمیمه را در این بخش مشاهده کنید</h6>
                        </div>
                        <hr/>
                        <div
                                class="hint-up"
                                v-for="(item, index) in content_attachments"
                                :key="index"
                        >
                            <div style="display: flex; justify-content:space-between;">
                                <p>{{ item.key }}</p>
                                <a :href="item.value" target="_blank">
                                    <v-btn
                                            color="#efbc59"
                                            style="color: white; left: 5px; position: absolute; border-radius: 25px;"
                                            width="20%"
                                    >نمایش
                                    </v-btn>
                                </a>
                            </div>
                            <hr style="color: #555555"/>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>

        <div class="filemeeting" v-else>
            <div v-if="data != null" class="boxs-filemeeting">
                <v-card width="90%" class="box-filemeeting">
                    <div class="r-text-boxs-filemeeting">
                        <h6>{{ content_title }}</h6>
                        <span>{{ parent_content_title }}</span>
                        <p>{{ content_voters }}بازدید</p>
                        <h5>{{ content_description }}</h5>
                    </div>
                    <div class="date-boxs-filemeeting">
                        <span>{{ content_duration }}</span>
                        <v-icon>query_builder</v-icon>
                    </div>
                </v-card>
                <v-card width="90%" class="box-received">
                    <h6>
                        برای دسترسی کامل و مشاهده این آموزش به صفحه دریافت این آموزش مراجعه
                        نمایید
                    </h6>
                    <div class="btn-box-received">
                        <v-btn color="#50ac17" width="90%" @click="GoPayment()">
                            <v-icon>vpn_key</v-icon>
                            صفحه دریافت آموزش
                        </v-btn>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
</template>
<script>
    import oracle from "@/oracle";

    export default {
        name: "movie",
        components: {},
        data() {
            return {
                currentPage: 1,
                pageCount: 0,
                pdfLink: null,
                numPages: undefined,
                id: "",
                videoLink: "",
                audioimk: "",
                accessible: false,
                like: false,
                data: null,
                DataAttach: [],
                content_title: "",
                parent_content_title: "",
                content_voters: "",
                content_description: "",
                content_duration: "",
                pdfViewerModal: false,
                ShowPDF: false,
                content_attachments: [],
            };
        },
        computed: {
            formattedZoom() {
                return Number.parseInt(this.scale * 100);
            },
        },
        methods: {
            minus() {
                this.currentPage--;
            },
            plus() {
                this.currentPage++;
            },
            GoPayment() {
                this.$router.push({name: "payment", query: {id: this.id}});
            },
            checkFavorite() {
                this.like =
                    this.data.stats != null &&
                    this.data.stats.record_favorite != null &&
                    this.data.stats.record_favorite;
                if (this.like) {
                    this.$root.$emit("fave_true");
                } else {
                    this.$root.$emit("fave_false");
                }
            },
            getDataMovie(response) {
                this.data = response.data;
                this.content_title = this.data.content_title;
                this.parent_content_title = this.data.parent.content_title;
                this.content_voters = this.data.content_voters;
                this.content_description = this.data.content_description;
                this.content_duration = this.data.content_duration;
                if (response.data.accessible != null && response.data.accessible) {
                    this.accessible = true;
                    if (
                        response.data.content_attachments != null &&
                        response.data.content_attachments.length > 0
                    ) {
                        this.content_attachments = response.data.content_attachments;
                    }
                    switch (response.data.content_format) {
                        case 0:
                            if (response.data.content_link_240) {
                                this.videoLink = response.data.content_link_240;
                            } else if (response.data.content_link_360) {
                                this.videoLink = response.data.content_link_360;
                            } else if (response.data.content_link_480) {
                                this.videoLink = response.data.content_link_480;
                            } else if (response.data.content_link_720) {
                                this.videoLink = response.data.content_link_720;
                            } else if (response.data.content_link_1080) {
                                this.videoLink = response.data.content_link_1080;
                            }
                            break;
                        case 1:
                            this.videoLink = response.data.content_audio;
                            break;
                        case 4:
                            this.pdfLink =
                                "https://download.mindandlove1.com/oksir.html?id=" +
                                response.data.content_pdf;
                            break;
                    }
                } else {
                    this.accessible = false;
                }
                this.checkFavorite();
                this.$root.$emit("content_title", response.data.content_title);
            },
            getDatafav(response) {
                if (
                    this.data.stats != null &&
                    this.data.stats.record_favorite != null &&
                    this.data.stats.record_favorite
                ) {
                    this.data.stats.record_favorite = false;
                } else {
                    if (this.data.stats == null) {
                        this.data.stats = {};
                    }
                    this.data.stats.record_favorite = true;
                }
                this.checkFavorite();
            },
        },

        mounted() {
            this.id = this.$route.query.id;
            oracle.axios("content/getOne", {content_id: this.id}, this.getDataMovie);
            this.$root.$on("fave", () => {
                let like;
                if (
                    this.data.stats != null &&
                    this.data.stats.record_favorite != null &&
                    this.data.stats.record_favorite
                ) {
                    like = true;
                } else {
                    like = false;
                }
                oracle.axios(
                    "content/setState",
                    {content_id: this.id, record_favorite: !like},
                    this.getDatafav
                );
            });
        },
    };
</script>

<style>
    .carousel {
        background-color: #606f7b;
    }

    .movie {
        background-image: url("/img/background.15817e10.jpg");
        height: 100%;
        position: relative;
        background-size: cover;
        padding: 0;
        z-index: 10;
        overflow: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .section-video {
        display: flex;
        justify-content: center;
    }

    .section-video .v-application {
        line-height: 0;
    }

    .title-movie h6 {
        font-size: 14px;
    }

    .hint-up .v-icon {
        color: antiquewhite;
    }

    .text-movie span {
        font-size: 13px;
    }

    .emoji-up .v-icon {
        color: #df2304;
    }

    .btn-offline button {
        color: #fff !important;
        width: 100%;
        border-radius: 0 !important;
    }

    .box-movie {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 0 auto;
        margin-top: 20px;
    }

    .emoji-up,
    .hint-up,
    .text-movie,
    .title-movie {
        padding: 10px;
    }

    .filemeeting {
        background-image: url("/img/background.15817e10.jpg");
        height: 100%;
        position: relative;
        background-size: cover;
        padding: 0;
        z-index: 10;
        overflow: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .boxs-filemeeting {
        margin-top: 70px;
    }

    .r-text-boxs-filemeeting {
        display: flex;
        flex-direction: column;
        padding: 5px;
    }

    .r-text-boxs-filemeeting h6 {
        font-size: 14px;
    }

    .r-text-boxs-filemeeting h5 {
        font-size: 13px;
        font-weight: 100;
    }

    .r-text-boxs-filemeeting span,
    .r-text-boxs-filemeeting p {
        font-size: 11px;
        color: #707070;
        padding: 2px;
    }

    .box-filemeeting,
    .box-received {
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
    }

    .box-filemeeting2 {
        /*display: flex;*/
        /*justify-content: space-between;*/
        margin: 0 auto;
    }

    .date-boxs-filemeeting {
        display: flex;
        align-items: flex-start;
        padding: 5px;
    }

    .date-boxs-filemeeting,
    .date-boxs-filemeeting .v-icon {
        font-size: 12px;
        color: #707070;
    }

    .date-boxs-filemeeting .v-icon {
        font-size: 15px;
    }

    .btn-box-received a {
        color: #fff !important;
    }

    .btn-box-received button {
        font-size: 12px !important;
        margin: 0 auto;
        display: flex;
        justify-items: center;
        align-items: center;
        position: absolute;
        bottom: 0;
        border-radius: none !important;
        color: #fff !important;
        margin-bottom: 15px !important;
    }

    .btn-box-received {
        padding: 20px;
    }

    .btn-box-received .v-icon {
        font-size: 15px;
        padding: 15px;
    }

    .box-received {
        margin-top: 20px;
        flex-direction: column;
    }

    .box-received h6 {
        color: #707070;
        padding: 20px 10px;
        font-size: 12px;
        font-weight: 100;
    }
</style>
